var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEnvironmentBannerVisible)?_c('div',{staticClass:"environment-banner"},[_vm._v(" Entorno de"),_c('br'),_vm._v("Integración ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }